import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepControls } from "../StepControls";
import { FOUNDING_DOCS_FIELD } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const FoundingDocuments: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10 lg:flex-row lg:items-center ">
        <h2 className="font-semibold flex-1">
          {t(registrationTitlesTrns.uploadFoundingDocuments)}
        </h2>

        <div className="flex-1">
          <RenderFormFields fields={FOUNDING_DOCS_FIELD} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
